import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export class Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export class AdhesionDashboard {
  date: Scalars['String'];
  done: Scalars['Int'];
  pending: Scalars['Int'];
};

export class AreaDashboard {
  dashboard?: Maybe<Array<FeedbackAreaDashboard>>;
  graph?: Maybe<Array<FeedbackAreaGraph>>;
};

export class AuthInput {
  code: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  redirectUri: Scalars['String'];
};

export class AuthType {
  token: Scalars['String'];
  user: User;
};

export class CompetenceDashboard {
  average?: Maybe<Scalars['Int']>;
  informative?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  percentage?: Maybe<Scalars['Float']>;
};

export class Country {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  flag: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  unities: Array<Unity>;
};

export class CreateCountryInput {
  flag: Scalars['String'];
  name: Scalars['String'];
};

export class CreateEnumTypeInput {
  description?: InputMaybe<Scalars['String']>;
  detail?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  value: Scalars['String'];
};

export class CreateEvaluationCompetenceInput {
  competenceEvaluation: Scalars['String'];
  description: Scalars['String'];
  informative: Scalars['String'];
  name: Scalars['String'];
};

export class CreateEvaluationInput {
  competence?: InputMaybe<Array<CreateEvaluationCompetenceInput>>;
  confirmationEmailMessage?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  name: Scalars['String'];
  start: Scalars['DateTime'];
};

export class CreateFeedbackInput {
  date: Scalars['DateTime'];
  description: Scalars['String'];
  files?: InputMaybe<Array<FeedbackFileInput>>;
  /** Enum: behavioral|technical */
  type?: InputMaybe<Scalars['String']>;
  user: Array<CreateFeedbackUserInput>;
};

export class CreateFeedbackUserInput {
  id: Scalars['String'];
};

export class CreateUnityInput {
  code?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export class CreateUserEvaluationCommentInput {
  message: Scalars['String'];
  pdiId: Scalars['String'];
};

export class CreateUserEvaluationPdiCompetenceInput {
  id: Scalars['String'];
};

export class CreateUserEvaluationPdiInput {
  activity: Scalars['String'];
  /** Enum: other|self-development|search-for-new-tools|improvement-courses|training-courses|specialization-courses|undergraduate-courses|language-course|foreign-courses|internships|feedback|implementation-of-indicators|implementation-of-improvements|reading|mba|networking|new-proposal|project|cost-reduction|meeting */
  activityType: Scalars['String'];
  competence: CreateUserEvaluationPdiCompetenceInput;
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
  /** Enum: pending|doing|done */
  status: Scalars['String'];
};

export class CreateUserEvaluationTaskInput {
  description: Scalars['String'];
  pdiId: Scalars['String'];
};

export class CreateUserInput {
  admissionDate: Scalars['DateTime'];
  area: Scalars['String'];
  costCenter: Scalars['String'];
  directorate: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  leadBy: CreateUserManagerInput;
  managerBy: CreateUserManagerInput;
  name: Scalars['String'];
  officeEmail?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** ENUM user|manager|leader */
  profile?: InputMaybe<Scalars['String']>;
  re: Scalars['String'];
  role: Scalars['String'];
  /** ENUM inactive|active */
  status?: InputMaybe<Scalars['String']>;
  unity: CreateUserUnityInput;
};

export class CreateUserManagerInput {
  id?: InputMaybe<Scalars['String']>;
};

export class CreateUserUnityInput {
  id?: InputMaybe<Scalars['String']>;
};

export class DefaultMessage {
  message: Scalars['String'];
  status: Scalars['Int'];
};

export class EnumType {
  description?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export class Evaluation {
  competences?: Maybe<Array<EvaluationCompetence>>;
  confirmationEmailMessage?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  isPDI?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  start: Scalars['DateTime'];
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userEvaluation?: Maybe<Array<UserEvaluation>>;
  usersCount?: Maybe<Scalars['Int']>;
};

export class EvaluationCompetence {
  competenceEvaluation: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  evaluation?: Maybe<Evaluation>;
  id: Scalars['ID'];
  informative: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userEvaluationCompetence?: Maybe<UserEvaluationCompetence>;
};

export class EvaluationMediaDashboard {
  average?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
};

export class EvaluationPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results: Array<Evaluation>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class Feedback {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  files?: Maybe<Array<FeedbackFile>>;
  id: Scalars['ID'];
  /** Enum: behavioral|technical */
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
};

export class FeedbackAreaDashboard {
  color: Scalars['String'];
  count: Scalars['Int'];
  name: Scalars['String'];
};

export class FeedbackAreaGraph {
  detail: Array<FeedbackAreaGraphDetail>;
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export class FeedbackAreaGraphDetail {
  color: Scalars['String'];
  count: Scalars['Int'];
  name: Scalars['String'];
};

export class FeedbackFile {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  feedback?: Maybe<Feedback>;
  fileKey: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  size?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

export class FeedbackFileInput {
  fileKey: Scalars['String'];
  name: Scalars['String'];
  size?: InputMaybe<Scalars['Int']>;
};

export class FeedbackObj {
  date: Scalars['DateTime'];
  feedbacks: Array<Feedback>;
};

export class FeedbackPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results: Array<FeedbackObj>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class FeedbackUnityDashboard {
  color: Scalars['String'];
  count: Scalars['Int'];
  name: Scalars['String'];
};

export class FeedbackUnityGraph {
  detail: Array<FeedbackUnityGraphDetail>;
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export class FeedbackUnityGraphDetail {
  color: Scalars['String'];
  count: Scalars['Int'];
  name: Scalars['String'];
};

export class ManagerRank {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results: Array<ManagerRankItem>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class ManagerRankItem {
  name: Scalars['String'];
  percentage: Scalars['String'];
};

export class Mutation {
  /** Create a new Country */
  createCountry: Country;
  /** Create new Enum Type */
  createEnumType: EnumType;
  createEvaluation: Evaluation;
  createFeedback: DefaultMessage;
  /** Create a new Unity */
  createUnity: Unity;
  /** Create new User */
  createUser: User;
  createUserEvaluationPdi: UserEvaluationPdi;
  createUserEvaluationPdiComment: UserEvaluationPdiComment;
  createUserEvaluationPdiTask: UserEvaluationPdiTask;
  extendEvaluation: DefaultMessage;
  finishUserEvaluation: UserEvaluation;
  login: AuthType;
  refreshAllEvaluationUsers: DefaultMessage;
  refreshEvaluation: DefaultMessage;
  refreshEvaluationUsers: DefaultMessage;
  /** Remove Country By ID */
  removeCountry: Country;
  removeEnumType: DefaultMessage;
  removeEvaluation: DefaultMessage;
  removeFeedback: DefaultMessage;
  removeFeedbackFile: DefaultMessage;
  /** Remove Unity */
  removeUnity: Unity;
  /** Remove User By Id */
  removeUser: DefaultMessage;
  removeUserEvaluationPdi: DefaultMessage;
  removeUserEvaluationPdiTask: DefaultMessage;
  restartUserEvaluation: DefaultMessage;
  updateEnumType: EnumType;
  updateEvaluation: Evaluation;
  updateFeedback: Feedback;
  /** Update Unity */
  updateUnity: Unity;
  /** Update User */
  updateUser: User;
  updateUserEvaluation: UserEvaluation;
  updateUserEvaluationPdi: UserEvaluationPdi;
  updateUserEvaluationPdiTask: UserEvaluationPdiTask;
  updateUserEvaluationPdiTaskStatus: UserEvaluationPdiTask;
};


export class MutationCreateCountryArgs {
  data: CreateCountryInput;
};


export class MutationCreateEnumTypeArgs {
  data: CreateEnumTypeInput;
};


export class MutationCreateEvaluationArgs {
  data: CreateEvaluationInput;
};


export class MutationCreateFeedbackArgs {
  data: CreateFeedbackInput;
};


export class MutationCreateUnityArgs {
  data: CreateUnityInput;
};


export class MutationCreateUserArgs {
  data: CreateUserInput;
};


export class MutationCreateUserEvaluationPdiArgs {
  data: CreateUserEvaluationPdiInput;
};


export class MutationCreateUserEvaluationPdiCommentArgs {
  data: CreateUserEvaluationCommentInput;
};


export class MutationCreateUserEvaluationPdiTaskArgs {
  data: CreateUserEvaluationTaskInput;
};


export class MutationExtendEvaluationArgs {
  date: Scalars['DateTime'];
  id: Scalars['String'];
};


export class MutationFinishUserEvaluationArgs {
  id: Scalars['String'];
};


export class MutationLoginArgs {
  data: AuthInput;
};


export class MutationRefreshEvaluationArgs {
  id: Scalars['String'];
};


export class MutationRefreshEvaluationUsersArgs {
  id: Scalars['String'];
};


export class MutationRemoveCountryArgs {
  id: Scalars['String'];
};


export class MutationRemoveEnumTypeArgs {
  id: Scalars['String'];
};


export class MutationRemoveEvaluationArgs {
  id: Scalars['String'];
};


export class MutationRemoveFeedbackArgs {
  id: Scalars['String'];
};


export class MutationRemoveFeedbackFileArgs {
  id: Scalars['String'];
};


export class MutationRemoveUnityArgs {
  id: Scalars['String'];
};


export class MutationRemoveUserArgs {
  id: Scalars['String'];
};


export class MutationRemoveUserEvaluationPdiArgs {
  id: Scalars['String'];
};


export class MutationRemoveUserEvaluationPdiTaskArgs {
  id: Scalars['String'];
};


export class MutationRestartUserEvaluationArgs {
  id: Scalars['String'];
};


export class MutationUpdateEnumTypeArgs {
  data: UpdateEnumTypeInput;
};


export class MutationUpdateEvaluationArgs {
  data: UpdateEvaluationInput;
};


export class MutationUpdateFeedbackArgs {
  data: UpdateFeedbackInput;
};


export class MutationUpdateUnityArgs {
  data: UpdateUnityInput;
};


export class MutationUpdateUserArgs {
  data: UpdateUserInput;
};


export class MutationUpdateUserEvaluationArgs {
  data: UpdateUserEvaluationInput;
};


export class MutationUpdateUserEvaluationPdiArgs {
  data: UpdateUserEvaluationPdiInput;
};


export class MutationUpdateUserEvaluationPdiTaskArgs {
  data: UpdateUserEvaluationPdiTaskInput;
};


export class MutationUpdateUserEvaluationPdiTaskStatusArgs {
  id: Scalars['String'];
};

export class QtdWithout {
  qtd: Scalars['Int'];
};

export class Query {
  adhesionDashboard: Array<AdhesionDashboard>;
  areaDashboard: AreaDashboard;
  checkDashboard: Scalars['Boolean'];
  competenceDashboard: Array<CompetenceDashboard>;
  /** Return All Countries */
  countries: Array<Country>;
  /** Get Country By ID */
  country: Country;
  /** Return User Logged */
  currentUser: User;
  enumByType: Array<EnumType>;
  enumType: EnumType;
  enumTypes: Array<EnumType>;
  evaluation: Evaluation;
  evaluationMediaDashboard: Array<EvaluationMediaDashboard>;
  evaluations: Array<Evaluation>;
  feedback: Feedback;
  feedbacks: Array<Feedback>;
  findLastEvaluation: Array<EvaluationCompetence>;
  /** Return All Unities By CountryId */
  getUnitiesByCountry: Array<Unity>;
  lastUserEvaluation: UserEvaluation;
  /** Return All Leaders from manager */
  leaderByManager: Array<User>;
  listUserEvaluationYear: UserEvaluationListYear;
  managerRank: ManagerRank;
  /** Return User Logged users */
  managerUsers: Array<User>;
  searchEvaluations: EvaluationPage;
  searchFeedback: FeedbackPage;
  searchUser: UserPage;
  searchUserEvaluations: UserEvaluationPage;
  /** Return All Unities */
  unities: Array<Unity>;
  /** Get Unity By ID */
  unity: Unity;
  unityDashboard: UnityDashboard;
  /** Return User By Id */
  user: User;
  /** Return User By Email */
  userByEmail: User;
  /** Return Top 10 User */
  userByName: Array<User>;
  /** Return Top 10 User */
  userCostCenter: UserCostCenter;
  userEvaluation: UserEvaluation;
  userEvaluationAdminDashboard: UserEvaluationAdminDashboardPage;
  userEvaluationDashboard: UserEvaluationDashboard;
  userEvaluationPdi: UserEvaluationPdi;
  userEvaluationPdiTask: UserEvaluationPdiTask;
  userMultiCostCenterById: Array<UserMultiCostCenter>;
  userQtdWithoutEvaluation: QtdWithout;
  /** Return All Users */
  users: Array<User>;
  /** Return All Users from profile */
  usersByProfile: Array<User>;
};


export class QueryAdhesionDashboardArgs {
  data: SearchDashboardInput;
};


export class QueryAreaDashboardArgs {
  data: SearchDashboardInput;
};


export class QueryCompetenceDashboardArgs {
  data: SearchDashboardInput;
};


export class QueryCountryArgs {
  id: Scalars['String'];
};


export class QueryEnumByTypeArgs {
  type: Scalars['String'];
};


export class QueryEnumTypeArgs {
  id: Scalars['String'];
};


export class QueryEvaluationArgs {
  id: Scalars['String'];
};


export class QueryEvaluationMediaDashboardArgs {
  data: SearchDashboardInput;
};


export class QueryFeedbackArgs {
  id: Scalars['String'];
};


export class QueryGetUnitiesByCountryArgs {
  id: Scalars['String'];
};


export class QueryLeaderByManagerArgs {
  id?: InputMaybe<Scalars['String']>;
  profile: Scalars['String'];
};


export class QueryManagerRankArgs {
  data: SearchDashboardInput;
};


export class QuerySearchEvaluationsArgs {
  data: SearchEvaluationInput;
};


export class QuerySearchFeedbackArgs {
  data: SearchFeedbackInput;
};


export class QuerySearchUserArgs {
  data: SearchUserInput;
};


export class QuerySearchUserEvaluationsArgs {
  data: SearchUserEvaluationInput;
};


export class QueryUnityArgs {
  id: Scalars['String'];
};


export class QueryUnityDashboardArgs {
  data: SearchDashboardInput;
};


export class QueryUserArgs {
  id: Scalars['String'];
};


export class QueryUserByEmailArgs {
  email: Scalars['String'];
};


export class QueryUserByNameArgs {
  name: Scalars['String'];
};


export class QueryUserEvaluationArgs {
  id: Scalars['String'];
};


export class QueryUserEvaluationAdminDashboardArgs {
  page?: InputMaybe<Scalars['Float']>;
};


export class QueryUserEvaluationDashboardArgs {
  data: SearchDashboardInput;
};


export class QueryUserEvaluationPdiArgs {
  id: Scalars['String'];
};


export class QueryUserEvaluationPdiTaskArgs {
  id: Scalars['String'];
};


export class QueryUserMultiCostCenterByIdArgs {
  id: Scalars['String'];
};


export class QueryUserQtdWithoutEvaluationArgs {
  id: Scalars['String'];
};


export class QueryUsersByProfileArgs {
  profile: Scalars['String'];
};

export class SearchDashboardInput {
  area?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  evaluation?: InputMaybe<Scalars['String']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['DateTime']>;
  unity?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export class SearchEvaluationInput {
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
};

export class SearchFeedbackInput {
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  /** Enum: behavioral|technical */
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export class SearchUserEvaluationInput {
  costCenter?: InputMaybe<Array<Scalars['String']>>;
  end?: InputMaybe<Scalars['DateTime']>;
  evaluation?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  /** enum:(pending|doing|done) */
  status?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchUserInput {
  keyword?: InputMaybe<Scalars['String']>;
  leaderId?: InputMaybe<Scalars['String']>;
  managerId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  profile?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class Unity {
  code?: Maybe<Scalars['String']>;
  country: Country;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  users: Array<User>;
};

export class UnityDashboard {
  dashboard?: Maybe<Array<FeedbackUnityDashboard>>;
  graph?: Maybe<Array<FeedbackUnityGraph>>;
};

export class UpdateEnumTypeInput {
  description?: InputMaybe<Scalars['String']>;
  detail?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export class UpdateEvaluationInput {
  competence?: InputMaybe<Array<CreateEvaluationCompetenceInput>>;
  confirmationEmailMessage?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  /** Enum: "pending"|"active"|"finished" */
  status?: InputMaybe<Scalars['String']>;
};

export class UpdateFeedbackInput {
  date?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<FeedbackFileInput>>;
  id: Scalars['String'];
  user?: InputMaybe<Array<CreateFeedbackUserInput>>;
};

export class UpdateUnityInput {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export class UpdateUserEvaluationCompetenceInput {
  id: Scalars['String'];
  score?: InputMaybe<Scalars['Int']>;
};

export class UpdateUserEvaluationInput {
  competences?: InputMaybe<Array<UpdateUserEvaluationCompetenceInput>>;
  declaration?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  obs?: InputMaybe<Scalars['String']>;
};

export class UpdateUserEvaluationPdiInput {
  activity?: InputMaybe<Scalars['String']>;
  /** Enum: other|self-development|search-for-new-tools|improvement-courses|training-courses|specialization-courses|undergraduate-courses|language-course|foreign-courses|internships|feedback|implementation-of-indicators|implementation-of-improvements|reading|mba|networking|new-proposal|project|cost-reduction|meeting */
  activityType?: InputMaybe<Scalars['String']>;
  competence?: InputMaybe<CreateUserEvaluationPdiCompetenceInput>;
  end?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  start?: InputMaybe<Scalars['DateTime']>;
  /** Enum: pending|doing|done */
  status?: InputMaybe<Scalars['String']>;
};

export class UpdateUserEvaluationPdiTaskInput {
  description: Scalars['String'];
  id: Scalars['String'];
};

export class UpdateUserInput {
  admissionDate?: InputMaybe<Scalars['DateTime']>;
  area?: InputMaybe<Scalars['String']>;
  costCenter?: InputMaybe<Scalars['String']>;
  directorate?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  leadBy?: InputMaybe<CreateUserManagerInput>;
  managerBy?: InputMaybe<CreateUserManagerInput>;
  name?: InputMaybe<Scalars['String']>;
  officeEmail?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  /** ENUM user|manager|leader */
  profile?: InputMaybe<Scalars['String']>;
  re?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  /** ENUM inactive|active */
  status?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<CreateUserUnityInput>;
};

export class User {
  admissionDate?: Maybe<Scalars['DateTime']>;
  area?: Maybe<Scalars['String']>;
  competenceAnswer?: Maybe<UserEvaluationCompetence>;
  costCenter?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  directorate?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  evaluation?: Maybe<Array<UserEvaluation>>;
  evaluationFinishedBy?: Maybe<Array<UserEvaluation>>;
  evaluationUpdatedBy?: Maybe<Array<UserEvaluation>>;
  evaluationsCreated?: Maybe<Array<Evaluation>>;
  feedback?: Maybe<Array<Feedback>>;
  feedbackCreatedBy?: Maybe<Array<Feedback>>;
  feedbackUpdatedBy?: Maybe<Array<Feedback>>;
  id: Scalars['ID'];
  leadBy?: Maybe<User>;
  leaderUserEvaluation?: Maybe<Array<UserEvaluation>>;
  managerBy?: Maybe<User>;
  managerUserEvaluation?: Maybe<Array<UserEvaluation>>;
  name?: Maybe<Scalars['String']>;
  officeEmail?: Maybe<Scalars['String']>;
  pdiTaskCreatedBy?: Maybe<Array<UserEvaluationPdiTask>>;
  pdiTaskUpdatedBy?: Maybe<Array<UserEvaluationPdiTask>>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  profile?: Maybe<Scalars['String']>;
  re: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
  userCostCenter?: Maybe<Array<UserMultiCostCenter>>;
  userCreator?: Maybe<Array<User>>;
  userEvaluationPdiComment?: Maybe<Array<UserEvaluationPdiComment>>;
  userLeader?: Maybe<Array<User>>;
  userManager?: Maybe<Array<User>>;
};

export class UserCostCenter {
  costCenter?: Maybe<Array<Scalars['String']>>;
};

export class UserEvaluation {
  area?: Maybe<Scalars['String']>;
  competence?: Maybe<Array<UserEvaluationCompetence>>;
  costCenter?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  declaration?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  directorate?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  evaluation?: Maybe<Evaluation>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  finishedBy?: Maybe<User>;
  id: Scalars['ID'];
  isRestart?: Maybe<Scalars['Boolean']>;
  leaderBy?: Maybe<User>;
  managerBy?: Maybe<User>;
  media?: Maybe<Scalars['Float']>;
  obs?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
};

export class UserEvaluationAdminDashboard {
  doing: Scalars['Int'];
  done: Scalars['Int'];
  pending: Scalars['Int'];
  userId: Scalars['String'];
  userName: Scalars['String'];
};

export class UserEvaluationAdminDashboardPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results: Array<UserEvaluationAdminDashboard>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class UserEvaluationCompetence {
  answerBy?: Maybe<User>;
  competence?: Maybe<EvaluationCompetence>;
  createdAt: Scalars['DateTime'];
  evaluation?: Maybe<UserEvaluation>;
  id: Scalars['ID'];
  pdi?: Maybe<Array<UserEvaluationPdi>>;
  score?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
};

export class UserEvaluationDashboard {
  doing: Scalars['Int'];
  done: Scalars['Int'];
  pending: Scalars['Int'];
};

export class UserEvaluationListYear {
  year: Array<Scalars['String']>;
};

export class UserEvaluationPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results: Array<UserEvaluation>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class UserEvaluationPdi {
  activity: Scalars['String'];
  activityType?: Maybe<Scalars['String']>;
  competence?: Maybe<UserEvaluationCompetence>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  start: Scalars['DateTime'];
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userEvaluationPdiComment?: Maybe<Array<UserEvaluationPdiComment>>;
  userEvaluationPdiTask?: Maybe<Array<UserEvaluationPdiTask>>;
};

export class UserEvaluationPdiComment {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  message: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userEvaluationPdi?: Maybe<UserEvaluationPdi>;
};

export class UserEvaluationPdiTask {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  pdi?: Maybe<UserEvaluationPdi>;
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
};

export class UserMultiCostCenter {
  costCenter?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  user: User;
};

export class UserPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results: Array<User>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export type UserFragment = { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null };

export type UserPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results: Array<{ id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null }> };

export type EvaluationCompetenceFragment = { id: string, name: string, description: string, competenceEvaluation: string, informative: string };

export type EvaluationFragment = { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null };

export type EvaluationPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results: Array<{ id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null }> };

export type UserEvaluationAdminDashboardFragment = { userName: string, userId: string, pending: number, doing: number, done: number };

export type UserToEvaluationPageFragment = { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null };

export type UserEvaluationCompetenceFragment = { createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null };

export type UserEvaluationPdiFragment = { id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null };

export type UserEvaluationPdiTaskFragment = { id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null };

export type UserEvaluationFragment = { id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null };

export type UserEvaluationPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> };

export type UserEvaluationAdminDashboardPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results: Array<{ userName: string, userId: string, pending: number, doing: number, done: number }> };

export type FeedbackFileFragment = { id: string, name: string, fileKey: string, url?: string | null, size?: number | null, createdAt: any, createdBy?: { id: string, name?: string | null } | null };

export type FeedbackFragment = { id: string, createdAt: any, date: any, deletedAt?: any | null, description: string, type: string, updatedAt: any, user?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, updatedBy?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, files?: Array<{ id: string, name: string, fileKey: string, url?: string | null, size?: number | null, createdAt: any, createdBy?: { id: string, name?: string | null } | null }> | null };

export type FeedbackObjFragment = { date: any, feedbacks: Array<{ id: string, createdAt: any, date: any, deletedAt?: any | null, description: string, type: string, updatedAt: any, user?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, updatedBy?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, files?: Array<{ id: string, name: string, fileKey: string, url?: string | null, size?: number | null, createdAt: any, createdBy?: { id: string, name?: string | null } | null }> | null }> };

export type FeedbackPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results: Array<{ date: any, feedbacks: Array<{ id: string, createdAt: any, date: any, deletedAt?: any | null, description: string, type: string, updatedAt: any, user?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, updatedBy?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, files?: Array<{ id: string, name: string, fileKey: string, url?: string | null, size?: number | null, createdAt: any, createdBy?: { id: string, name?: string | null } | null }> | null }> }> };

export type CountryFragment = { id: string, name: string, flag: string };

export type UnityFragment = { id: string, name: string, country: { id: string, name: string, flag: string } };

export type DefaultMessageFragment = { message: string, status: number };

export type UnityDashboardFragment = { dashboard?: Array<{ color: string, count: number, name: string }> | null, graph?: Array<{ month: number, year: number, detail: Array<{ color: string, count: number, name: string }> }> | null };

export type ManagerRankFragment = { currentPage: number, nextPage: boolean, previousPage: boolean, totalCount: number, totalPage: number, results: Array<{ name: string, percentage: string }> };

export type ManagerRankItemFragment = { name: string, percentage: string };

export type AreaDashboardFragment = { dashboard?: Array<{ color: string, count: number, name: string }> | null, graph?: Array<{ month: number, year: number, detail: Array<{ color: string, count: number, name: string }> }> | null };

export type AdhesionDashboardFragment = { date: string, done: number, pending: number };

export type EvaluationMediaDashboardFragment = { average?: number | null, count?: number | null };

export type CompetenceDashboardFragment = { average?: number | null, informative?: string | null, name: string, percentage?: number | null };

export type UserEvaluationPdiCommentFragment = { id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null } | null, userEvaluationPdi?: { id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null } | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { countries: Array<{ id: string, name: string, flag: string }> };

export type UnityDashboardQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type UnityDashboardQuery = { unityDashboard: { dashboard?: Array<{ color: string, count: number, name: string }> | null, graph?: Array<{ month: number, year: number, detail: Array<{ color: string, count: number, name: string }> }> | null } };

export type AreaDashboardQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type AreaDashboardQuery = { areaDashboard: { dashboard?: Array<{ color: string, count: number, name: string }> | null, graph?: Array<{ month: number, year: number, detail: Array<{ color: string, count: number, name: string }> }> | null } };

export type ManagerRankQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type ManagerRankQuery = { managerRank: { currentPage: number, nextPage: boolean, previousPage: boolean, totalCount: number, totalPage: number, results: Array<{ name: string, percentage: string }> } };

export type AdhesionDashboardQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type AdhesionDashboardQuery = { adhesionDashboard: Array<{ date: string, done: number, pending: number }> };

export type EvaluationMediaDashboardQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type EvaluationMediaDashboardQuery = { evaluationMediaDashboard: Array<{ average?: number | null, count?: number | null }> };

export type CompetenceDashboardQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type CompetenceDashboardQuery = { competenceDashboard: Array<{ average?: number | null, informative?: string | null, name: string, percentage?: number | null }> };

export type ListUserEvaluationYearQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUserEvaluationYearQuery = { listUserEvaluationYear: { year: Array<string> } };

export type EvaluationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type EvaluationQuery = { evaluation: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } };

export type EvaluationsQueryVariables = Exact<{ [key: string]: never; }>;


export type EvaluationsQuery = { evaluations: Array<{ id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null }> };

export type SearchEvaluationsQueryVariables = Exact<{
  data: SearchEvaluationInput;
}>;


export type SearchEvaluationsQuery = { searchEvaluations: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results: Array<{ id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null }> } };

export type CreateEvaluationMutationVariables = Exact<{
  input: CreateEvaluationInput;
}>;


export type CreateEvaluationMutation = { createEvaluation: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } };

export type FindLastEvaluationQueryVariables = Exact<{ [key: string]: never; }>;


export type FindLastEvaluationQuery = { findLastEvaluation: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> };

export type UpdateEvaluationMutationVariables = Exact<{
  input: UpdateEvaluationInput;
}>;


export type UpdateEvaluationMutation = { updateEvaluation: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } };

export type RemoveEvaluationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveEvaluationMutation = { removeEvaluation: { message: string } };

export type UserEvaluationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserEvaluationQuery = { userEvaluation: { id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null } };

export type LastUserEvaluationQueryVariables = Exact<{ [key: string]: never; }>;


export type LastUserEvaluationQuery = { lastUserEvaluation: { id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null } };

export type UserEvaluationPdiQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserEvaluationPdiQuery = { userEvaluationPdi: { id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null } };

export type RemoveUserEvaluationPdiMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveUserEvaluationPdiMutation = { removeUserEvaluationPdi: { message: string, status: number } };

export type CreateUserEvaluationPdiMutationVariables = Exact<{
  data: CreateUserEvaluationPdiInput;
}>;


export type CreateUserEvaluationPdiMutation = { createUserEvaluationPdi: { id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null } };

export type UpdateUserEvaluationPdiMutationVariables = Exact<{
  data: UpdateUserEvaluationPdiInput;
}>;


export type UpdateUserEvaluationPdiMutation = { updateUserEvaluationPdi: { id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null } };

export type UserEvaluationDashboardQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type UserEvaluationDashboardQuery = { userEvaluationDashboard: { doing: number, done: number, pending: number } };

export type UserEvaluationAdminDashboardQueryVariables = Exact<{
  data: Scalars['Float'];
}>;


export type UserEvaluationAdminDashboardQuery = { userEvaluationAdminDashboard: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results: Array<{ userName: string, userId: string, pending: number, doing: number, done: number }> } };

export type CheckDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckDashboardQuery = { checkDashboard: boolean };

export type UpdateUserEvaluationMutationVariables = Exact<{
  data: UpdateUserEvaluationInput;
}>;


export type UpdateUserEvaluationMutation = { updateUserEvaluation: { id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null } };

export type FinishUserEvaluationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type FinishUserEvaluationMutation = { finishUserEvaluation: { id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null } };

export type RestartUserEvaluationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestartUserEvaluationMutation = { restartUserEvaluation: { message: string, status: number } };

export type ExtendEvaluationMutationVariables = Exact<{
  date: Scalars['DateTime'];
  id: Scalars['String'];
}>;


export type ExtendEvaluationMutation = { extendEvaluation: { message: string, status: number } };

export type UserQtdWithoutEvaluationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserQtdWithoutEvaluationQuery = { userQtdWithoutEvaluation: { qtd: number } };

export type RefreshEvaluationUsersMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RefreshEvaluationUsersMutation = { refreshEvaluationUsers: { message: string, status: number } };

export type UserCostCenterQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCostCenterQuery = { userCostCenter: { costCenter?: Array<string> | null } };

export type CreateUserEvaluationPdiCommentMutationVariables = Exact<{
  data: CreateUserEvaluationCommentInput;
}>;


export type CreateUserEvaluationPdiCommentMutation = { createUserEvaluationPdiComment: { id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null } | null, userEvaluationPdi?: { id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null } | null } };

export type CreateUserEvaluationPdiTaskMutationVariables = Exact<{
  data: CreateUserEvaluationTaskInput;
}>;


export type CreateUserEvaluationPdiTaskMutation = { createUserEvaluationPdiTask: { id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null } };

export type UpdateUserEvaluationPdiTaskMutationVariables = Exact<{
  data: UpdateUserEvaluationPdiTaskInput;
}>;


export type UpdateUserEvaluationPdiTaskMutation = { updateUserEvaluationPdiTask: { id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null } };

export type UpdateUserEvaluationPdiTaskStatusMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UpdateUserEvaluationPdiTaskStatusMutation = { updateUserEvaluationPdiTaskStatus: { id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null } };

export type RemoveUserEvaluationPdiTaskMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveUserEvaluationPdiTaskMutation = { removeUserEvaluationPdiTask: { message: string, status: number } };

export type CreateFeedbackMutationVariables = Exact<{
  input: CreateFeedbackInput;
}>;


export type CreateFeedbackMutation = { createFeedback: { message: string, status: number } };

export type UpdateFeedbackMutationVariables = Exact<{
  input: UpdateFeedbackInput;
}>;


export type UpdateFeedbackMutation = { updateFeedback: { id: string, createdAt: any, date: any, deletedAt?: any | null, description: string, type: string, updatedAt: any, user?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, updatedBy?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, files?: Array<{ id: string, name: string, fileKey: string, url?: string | null, size?: number | null, createdAt: any, createdBy?: { id: string, name?: string | null } | null }> | null } };

export type RemoveFeedbackMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveFeedbackMutation = { removeFeedback: { message: string, status: number } };

export type RemoveFeedbackFileMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveFeedbackFileMutation = { removeFeedbackFile: { message: string, status: number } };

export type SearchFeedbackQueryVariables = Exact<{
  data: SearchFeedbackInput;
}>;


export type SearchFeedbackQuery = { searchFeedback: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results: Array<{ date: any, feedbacks: Array<{ id: string, createdAt: any, date: any, deletedAt?: any | null, description: string, type: string, updatedAt: any, user?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, updatedBy?: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } | null, files?: Array<{ id: string, name: string, fileKey: string, url?: string | null, size?: number | null, createdAt: any, createdBy?: { id: string, name?: string | null } | null }> | null }> }> } };

export type LoginMutationVariables = Exact<{
  code: Scalars['String'];
  redirectUri: Scalars['String'];
  email: Scalars['String'];
}>;


export type LoginMutation = { login: { token: string, user: { id: string, name?: string | null, email?: string | null, re: string, photo?: string | null, profile?: string | null, status?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, createdBy?: { id: string, name?: string | null } | null } } };

export type GetUnitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitiesQuery = { unities: Array<{ id: string, name: string }> };

export type GetUnitiesByCountryQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type GetUnitiesByCountryQuery = { getUnitiesByCountry: Array<{ id: string, name: string, country: { id: string, name: string, flag: string } }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { users: Array<{ id: string, name?: string | null, email?: string | null, re: string, photo?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null }> };

export type SearchUserQueryVariables = Exact<{
  data: SearchUserInput;
}>;


export type SearchUserQuery = { searchUser: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results: Array<{ id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null }> } };

export type UsersByProfileQueryVariables = Exact<{
  data: Scalars['String'];
}>;


export type UsersByProfileQuery = { usersByProfile: Array<{ id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null }> };

export type LeadersByManagerQueryVariables = Exact<{
  profile: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
}>;


export type LeadersByManagerQuery = { leaderByManager: Array<{ id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null }> };

export type UserByNameQueryVariables = Exact<{
  data: Scalars['String'];
}>;


export type UserByNameQuery = { userByName: Array<{ id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null }> };

export type SearchUserEvaluationsQueryVariables = Exact<{
  data: SearchUserEvaluationInput;
}>;


export type SearchUserEvaluationsQuery = { searchUserEvaluations: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> } };

export type UserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserQuery = { user: { id: string, photo?: string | null, name?: string | null, profile?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null, evaluation?: Array<{ id: string, createdAt: any, declaration?: boolean | null, deletedAt?: any | null, email?: string | null, finishedAt?: any | null, media?: number | null, obs?: string | null, status: string, updatedAt: any, isRestart?: boolean | null, user?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, leadBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, managerBy?: { id: string, name?: string | null, email?: string | null, profile?: string | null } | null, feedback?: Array<{ id: string }> | null, unity?: { id: string, name: string } | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null } | null, evaluation?: { id: string, name: string, confirmationEmailMessage?: string | null, createdAt: any, deletedAt?: any | null, end: any, start: any, updatedAt: any, usersCount?: number | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null } | null, competences?: Array<{ id: string, name: string, description: string, competenceEvaluation: string, informative: string }> | null } | null, competence?: Array<{ createdAt: any, id: string, score?: number | null, updatedAt: any, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null, answerBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, createdBy?: { id: string, photo?: string | null, name?: string | null, re: string, costCenter?: string | null, role?: string | null, area?: string | null, directorate?: string | null, admissionDate?: any | null, phone?: string | null, email?: string | null, officeEmail?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } | null, pdi?: Array<{ id: string, status: string, activity: string, activityType?: string | null, createdAt: any, deletedAt?: any | null, updatedAt: any, start: any, end: any, userEvaluationPdiComment?: Array<{ id: string, message: string, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: { id: string, name?: string | null, role?: string | null, profile?: string | null } | null }> | null, competence?: { id: string, competence?: { id: string, name: string, description: string, competenceEvaluation: string, informative: string } | null } | null, userEvaluationPdiTask?: Array<{ id: string, description: string, status: string, createdAt: any, updatedAt: any, deletedAt?: any | null, pdi?: { id: string, status: string } | null }> | null }> | null }> | null }> | null } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { createUser: { id: string, name?: string | null, email?: string | null, re: string, photo?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { updateUser: { id: string, name?: string | null, email?: string | null, re: string, photo?: string | null, profile?: string | null, status?: string | null, unity?: { id: string, name: string, country: { id: string, name: string, flag: string } } | null } };

export type RemoveUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveUserMutation = { removeUser: { message: string } };

export const CountryFragmentDoc = gql`
    fragment Country on Country {
  id
  name
  flag
}
    `;
export const UnityFragmentDoc = gql`
    fragment Unity on Unity {
  id
  name
  country {
    ...Country
  }
}
    ${CountryFragmentDoc}`;
export const UserToEvaluationPageFragmentDoc = gql`
    fragment UserToEvaluationPage on User {
  id
  photo
  name
  re
  costCenter
  role
  area
  directorate
  admissionDate
  phone
  email
  officeEmail
  profile
  status
  leadBy {
    id
    name
    email
    profile
  }
  managerBy {
    id
    name
    email
    profile
  }
  feedback {
    id
  }
  unity {
    id
    name
  }
  createdBy {
    id
    photo
    name
    re
    costCenter
    role
    area
    directorate
    admissionDate
    phone
    email
    officeEmail
    profile
    status
  }
}
    `;
export const EvaluationCompetenceFragmentDoc = gql`
    fragment EvaluationCompetence on EvaluationCompetence {
  id
  name
  description
  competenceEvaluation
  informative
}
    `;
export const EvaluationFragmentDoc = gql`
    fragment Evaluation on Evaluation {
  id
  name
  confirmationEmailMessage
  createdAt
  deletedAt
  end
  start
  updatedAt
  usersCount
  status
  createdBy {
    id
    photo
    name
    re
    costCenter
    role
    area
    directorate
    admissionDate
    phone
    email
    officeEmail
    profile
    status
  }
  competences {
    ...EvaluationCompetence
  }
}
    ${EvaluationCompetenceFragmentDoc}`;
export const UserEvaluationPdiTaskFragmentDoc = gql`
    fragment UserEvaluationPdiTask on UserEvaluationPdiTask {
  id
  description
  status
  createdAt
  updatedAt
  deletedAt
  pdi {
    id
    status
  }
}
    `;
export const UserEvaluationPdiFragmentDoc = gql`
    fragment UserEvaluationPdi on UserEvaluationPdi {
  id
  status
  activity
  activityType
  createdAt
  deletedAt
  updatedAt
  start
  end
  userEvaluationPdiComment {
    id
    message
    createdAt
    updatedAt
    deletedAt
    user {
      id
      name
      role
      profile
    }
  }
  competence {
    id
    competence {
      ...EvaluationCompetence
    }
  }
  userEvaluationPdiTask {
    ...UserEvaluationPdiTask
  }
}
    ${EvaluationCompetenceFragmentDoc}
${UserEvaluationPdiTaskFragmentDoc}`;
export const UserEvaluationCompetenceFragmentDoc = gql`
    fragment UserEvaluationCompetence on UserEvaluationCompetence {
  createdAt
  id
  score
  updatedAt
  competence {
    id
    name
  }
  answerBy {
    id
    photo
    name
    re
    costCenter
    role
    area
    directorate
    createdBy {
      id
      photo
      name
      re
      costCenter
      role
      area
      directorate
      admissionDate
      phone
      email
      officeEmail
      profile
      status
      unity {
        ...Unity
      }
    }
    admissionDate
    phone
    email
    officeEmail
    profile
    status
    unity {
      ...Unity
    }
  }
  pdi {
    ...UserEvaluationPdi
  }
  competence {
    ...EvaluationCompetence
  }
}
    ${UnityFragmentDoc}
${UserEvaluationPdiFragmentDoc}
${EvaluationCompetenceFragmentDoc}`;
export const UserEvaluationFragmentDoc = gql`
    fragment UserEvaluation on UserEvaluation {
  id
  createdAt
  declaration
  deletedAt
  email
  finishedAt
  media
  obs
  status
  updatedAt
  isRestart
  user {
    ...UserToEvaluationPage
  }
  evaluation {
    ...Evaluation
  }
  competence {
    ...UserEvaluationCompetence
  }
}
    ${UserToEvaluationPageFragmentDoc}
${EvaluationFragmentDoc}
${UserEvaluationCompetenceFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  photo
  name
  profile
  re
  costCenter
  role
  area
  directorate
  leadBy {
    id
    name
    email
    profile
  }
  managerBy {
    id
    name
    email
    profile
  }
  createdBy {
    id
    photo
    name
    re
    costCenter
    role
    area
    directorate
    admissionDate
    phone
    email
    officeEmail
    profile
    status
    unity {
      ...Unity
    }
  }
  admissionDate
  phone
  email
  officeEmail
  profile
  status
  unity {
    ...Unity
  }
  evaluation {
    ...UserEvaluation
  }
}
    ${UnityFragmentDoc}
${UserEvaluationFragmentDoc}`;
export const UserPageFragmentDoc = gql`
    fragment UserPage on UserPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const EvaluationPageFragmentDoc = gql`
    fragment EvaluationPage on EvaluationPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...Evaluation
  }
}
    ${EvaluationFragmentDoc}`;
export const UserEvaluationPageFragmentDoc = gql`
    fragment UserEvaluationPage on UserEvaluationPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...UserEvaluation
  }
}
    ${UserEvaluationFragmentDoc}`;
export const UserEvaluationAdminDashboardFragmentDoc = gql`
    fragment UserEvaluationAdminDashboard on UserEvaluationAdminDashboard {
  userName
  userId
  pending
  doing
  done
}
    `;
export const UserEvaluationAdminDashboardPageFragmentDoc = gql`
    fragment UserEvaluationAdminDashboardPage on UserEvaluationAdminDashboardPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...UserEvaluationAdminDashboard
  }
}
    ${UserEvaluationAdminDashboardFragmentDoc}`;
export const FeedbackFileFragmentDoc = gql`
    fragment FeedbackFile on FeedbackFile {
  id
  name
  fileKey
  url
  size
  createdAt
  createdBy {
    id
    name
  }
}
    `;
export const FeedbackFragmentDoc = gql`
    fragment Feedback on Feedback {
  id
  createdAt
  date
  deletedAt
  description
  type
  updatedAt
  user {
    ...User
  }
  createdBy {
    ...User
  }
  updatedBy {
    ...User
  }
  files {
    ...FeedbackFile
  }
}
    ${UserFragmentDoc}
${FeedbackFileFragmentDoc}`;
export const FeedbackObjFragmentDoc = gql`
    fragment FeedbackObj on FeedbackObj {
  date
  feedbacks {
    ...Feedback
  }
}
    ${FeedbackFragmentDoc}`;
export const FeedbackPageFragmentDoc = gql`
    fragment FeedbackPage on FeedbackPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...FeedbackObj
  }
}
    ${FeedbackObjFragmentDoc}`;
export const DefaultMessageFragmentDoc = gql`
    fragment DefaultMessage on DefaultMessage {
  message
  status
}
    `;
export const UnityDashboardFragmentDoc = gql`
    fragment UnityDashboard on UnityDashboard {
  dashboard {
    color
    count
    name
  }
  graph {
    month
    year
    detail {
      color
      count
      name
    }
  }
}
    `;
export const ManagerRankItemFragmentDoc = gql`
    fragment ManagerRankItem on ManagerRankItem {
  name
  percentage
}
    `;
export const ManagerRankFragmentDoc = gql`
    fragment ManagerRank on ManagerRank {
  currentPage
  nextPage
  previousPage
  totalCount
  totalPage
  results {
    ...ManagerRankItem
  }
}
    ${ManagerRankItemFragmentDoc}`;
export const AreaDashboardFragmentDoc = gql`
    fragment AreaDashboard on AreaDashboard {
  dashboard {
    color
    count
    name
  }
  graph {
    month
    year
    detail {
      color
      count
      name
    }
  }
}
    `;
export const AdhesionDashboardFragmentDoc = gql`
    fragment AdhesionDashboard on AdhesionDashboard {
  date
  done
  pending
}
    `;
export const EvaluationMediaDashboardFragmentDoc = gql`
    fragment EvaluationMediaDashboard on EvaluationMediaDashboard {
  average
  count
}
    `;
export const CompetenceDashboardFragmentDoc = gql`
    fragment CompetenceDashboard on CompetenceDashboard {
  average
  informative
  name
  percentage
}
    `;
export const UserEvaluationPdiCommentFragmentDoc = gql`
    fragment UserEvaluationPdiComment on UserEvaluationPdiComment {
  id
  message
  createdAt
  updatedAt
  deletedAt
  user {
    id
    name
    role
  }
  userEvaluationPdi {
    ...UserEvaluationPdi
  }
}
    ${UserEvaluationPdiFragmentDoc}`;
export const GetCountriesDocument = gql`
    query GetCountries {
  countries {
    id
    name
    flag
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountriesGQL extends Apollo.Query<GetCountriesQuery, GetCountriesQueryVariables> {
    document = GetCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnityDashboardDocument = gql`
    query UnityDashboard($data: SearchDashboardInput!) {
  unityDashboard(data: $data) {
    ...UnityDashboard
  }
}
    ${UnityDashboardFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UnityDashboardGQL extends Apollo.Query<UnityDashboardQuery, UnityDashboardQueryVariables> {
    document = UnityDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AreaDashboardDocument = gql`
    query AreaDashboard($data: SearchDashboardInput!) {
  areaDashboard(data: $data) {
    ...AreaDashboard
  }
}
    ${AreaDashboardFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AreaDashboardGQL extends Apollo.Query<AreaDashboardQuery, AreaDashboardQueryVariables> {
    document = AreaDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManagerRankDocument = gql`
    query ManagerRank($data: SearchDashboardInput!) {
  managerRank(data: $data) {
    ...ManagerRank
  }
}
    ${ManagerRankFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ManagerRankGQL extends Apollo.Query<ManagerRankQuery, ManagerRankQueryVariables> {
    document = ManagerRankDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AdhesionDashboardDocument = gql`
    query AdhesionDashboard($data: SearchDashboardInput!) {
  adhesionDashboard(data: $data) {
    ...AdhesionDashboard
  }
}
    ${AdhesionDashboardFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AdhesionDashboardGQL extends Apollo.Query<AdhesionDashboardQuery, AdhesionDashboardQueryVariables> {
    document = AdhesionDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EvaluationMediaDashboardDocument = gql`
    query EvaluationMediaDashboard($data: SearchDashboardInput!) {
  evaluationMediaDashboard(data: $data) {
    ...EvaluationMediaDashboard
  }
}
    ${EvaluationMediaDashboardFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EvaluationMediaDashboardGQL extends Apollo.Query<EvaluationMediaDashboardQuery, EvaluationMediaDashboardQueryVariables> {
    document = EvaluationMediaDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompetenceDashboardDocument = gql`
    query CompetenceDashboard($data: SearchDashboardInput!) {
  competenceDashboard(data: $data) {
    ...CompetenceDashboard
  }
}
    ${CompetenceDashboardFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompetenceDashboardGQL extends Apollo.Query<CompetenceDashboardQuery, CompetenceDashboardQueryVariables> {
    document = CompetenceDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListUserEvaluationYearDocument = gql`
    query ListUserEvaluationYear {
  listUserEvaluationYear {
    year
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListUserEvaluationYearGQL extends Apollo.Query<ListUserEvaluationYearQuery, ListUserEvaluationYearQueryVariables> {
    document = ListUserEvaluationYearDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EvaluationDocument = gql`
    query Evaluation($id: String!) {
  evaluation(id: $id) {
    ...Evaluation
  }
}
    ${EvaluationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EvaluationGQL extends Apollo.Query<EvaluationQuery, EvaluationQueryVariables> {
    document = EvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EvaluationsDocument = gql`
    query Evaluations {
  evaluations {
    ...Evaluation
  }
}
    ${EvaluationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EvaluationsGQL extends Apollo.Query<EvaluationsQuery, EvaluationsQueryVariables> {
    document = EvaluationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchEvaluationsDocument = gql`
    query SearchEvaluations($data: SearchEvaluationInput!) {
  searchEvaluations(data: $data) {
    ...EvaluationPage
  }
}
    ${EvaluationPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchEvaluationsGQL extends Apollo.Query<SearchEvaluationsQuery, SearchEvaluationsQueryVariables> {
    document = SearchEvaluationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEvaluationDocument = gql`
    mutation CreateEvaluation($input: CreateEvaluationInput!) {
  createEvaluation(data: $input) {
    ...Evaluation
  }
}
    ${EvaluationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEvaluationGQL extends Apollo.Mutation<CreateEvaluationMutation, CreateEvaluationMutationVariables> {
    document = CreateEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindLastEvaluationDocument = gql`
    query FindLastEvaluation {
  findLastEvaluation {
    ...EvaluationCompetence
  }
}
    ${EvaluationCompetenceFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FindLastEvaluationGQL extends Apollo.Query<FindLastEvaluationQuery, FindLastEvaluationQueryVariables> {
    document = FindLastEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEvaluationDocument = gql`
    mutation UpdateEvaluation($input: UpdateEvaluationInput!) {
  updateEvaluation(data: $input) {
    ...Evaluation
  }
}
    ${EvaluationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEvaluationGQL extends Apollo.Mutation<UpdateEvaluationMutation, UpdateEvaluationMutationVariables> {
    document = UpdateEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveEvaluationDocument = gql`
    mutation RemoveEvaluation($id: String!) {
  removeEvaluation(id: $id) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveEvaluationGQL extends Apollo.Mutation<RemoveEvaluationMutation, RemoveEvaluationMutationVariables> {
    document = RemoveEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserEvaluationDocument = gql`
    query UserEvaluation($id: String!) {
  userEvaluation(id: $id) {
    ...UserEvaluation
  }
}
    ${UserEvaluationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserEvaluationGQL extends Apollo.Query<UserEvaluationQuery, UserEvaluationQueryVariables> {
    document = UserEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LastUserEvaluationDocument = gql`
    query lastUserEvaluation {
  lastUserEvaluation {
    ...UserEvaluation
  }
}
    ${UserEvaluationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LastUserEvaluationGQL extends Apollo.Query<LastUserEvaluationQuery, LastUserEvaluationQueryVariables> {
    document = LastUserEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserEvaluationPdiDocument = gql`
    query UserEvaluationPdi($id: String!) {
  userEvaluationPdi(id: $id) {
    ...UserEvaluationPdi
  }
}
    ${UserEvaluationPdiFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserEvaluationPdiGQL extends Apollo.Query<UserEvaluationPdiQuery, UserEvaluationPdiQueryVariables> {
    document = UserEvaluationPdiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUserEvaluationPdiDocument = gql`
    mutation RemoveUserEvaluationPdi($id: String!) {
  removeUserEvaluationPdi(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUserEvaluationPdiGQL extends Apollo.Mutation<RemoveUserEvaluationPdiMutation, RemoveUserEvaluationPdiMutationVariables> {
    document = RemoveUserEvaluationPdiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserEvaluationPdiDocument = gql`
    mutation CreateUserEvaluationPdi($data: CreateUserEvaluationPdiInput!) {
  createUserEvaluationPdi(data: $data) {
    ...UserEvaluationPdi
  }
}
    ${UserEvaluationPdiFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserEvaluationPdiGQL extends Apollo.Mutation<CreateUserEvaluationPdiMutation, CreateUserEvaluationPdiMutationVariables> {
    document = CreateUserEvaluationPdiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserEvaluationPdiDocument = gql`
    mutation UpdateUserEvaluationPdi($data: UpdateUserEvaluationPdiInput!) {
  updateUserEvaluationPdi(data: $data) {
    ...UserEvaluationPdi
  }
}
    ${UserEvaluationPdiFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserEvaluationPdiGQL extends Apollo.Mutation<UpdateUserEvaluationPdiMutation, UpdateUserEvaluationPdiMutationVariables> {
    document = UpdateUserEvaluationPdiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserEvaluationDashboardDocument = gql`
    query UserEvaluationDashboard($data: SearchDashboardInput!) {
  userEvaluationDashboard(data: $data) {
    doing
    done
    pending
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserEvaluationDashboardGQL extends Apollo.Query<UserEvaluationDashboardQuery, UserEvaluationDashboardQueryVariables> {
    document = UserEvaluationDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserEvaluationAdminDashboardDocument = gql`
    query UserEvaluationAdminDashboard($data: Float!) {
  userEvaluationAdminDashboard(page: $data) {
    ...UserEvaluationAdminDashboardPage
  }
}
    ${UserEvaluationAdminDashboardPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserEvaluationAdminDashboardGQL extends Apollo.Query<UserEvaluationAdminDashboardQuery, UserEvaluationAdminDashboardQueryVariables> {
    document = UserEvaluationAdminDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckDashboardDocument = gql`
    query CheckDashboard {
  checkDashboard
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckDashboardGQL extends Apollo.Query<CheckDashboardQuery, CheckDashboardQueryVariables> {
    document = CheckDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserEvaluationDocument = gql`
    mutation UpdateUserEvaluation($data: UpdateUserEvaluationInput!) {
  updateUserEvaluation(data: $data) {
    ...UserEvaluation
  }
}
    ${UserEvaluationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserEvaluationGQL extends Apollo.Mutation<UpdateUserEvaluationMutation, UpdateUserEvaluationMutationVariables> {
    document = UpdateUserEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinishUserEvaluationDocument = gql`
    mutation FinishUserEvaluation($id: String!) {
  finishUserEvaluation(id: $id) {
    ...UserEvaluation
  }
}
    ${UserEvaluationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FinishUserEvaluationGQL extends Apollo.Mutation<FinishUserEvaluationMutation, FinishUserEvaluationMutationVariables> {
    document = FinishUserEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestartUserEvaluationDocument = gql`
    mutation RestartUserEvaluation($id: String!) {
  restartUserEvaluation(id: $id) {
    message
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestartUserEvaluationGQL extends Apollo.Mutation<RestartUserEvaluationMutation, RestartUserEvaluationMutationVariables> {
    document = RestartUserEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExtendEvaluationDocument = gql`
    mutation ExtendEvaluation($date: DateTime!, $id: String!) {
  extendEvaluation(date: $date, id: $id) {
    message
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExtendEvaluationGQL extends Apollo.Mutation<ExtendEvaluationMutation, ExtendEvaluationMutationVariables> {
    document = ExtendEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserQtdWithoutEvaluationDocument = gql`
    query UserQtdWithoutEvaluation($id: String!) {
  userQtdWithoutEvaluation(id: $id) {
    qtd
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserQtdWithoutEvaluationGQL extends Apollo.Query<UserQtdWithoutEvaluationQuery, UserQtdWithoutEvaluationQueryVariables> {
    document = UserQtdWithoutEvaluationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshEvaluationUsersDocument = gql`
    mutation RefreshEvaluationUsers($id: String!) {
  refreshEvaluationUsers(id: $id) {
    message
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshEvaluationUsersGQL extends Apollo.Mutation<RefreshEvaluationUsersMutation, RefreshEvaluationUsersMutationVariables> {
    document = RefreshEvaluationUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserCostCenterDocument = gql`
    query userCostCenter {
  userCostCenter {
    costCenter
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserCostCenterGQL extends Apollo.Query<UserCostCenterQuery, UserCostCenterQueryVariables> {
    document = UserCostCenterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserEvaluationPdiCommentDocument = gql`
    mutation CreateUserEvaluationPdiComment($data: CreateUserEvaluationCommentInput!) {
  createUserEvaluationPdiComment(data: $data) {
    ...UserEvaluationPdiComment
  }
}
    ${UserEvaluationPdiCommentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserEvaluationPdiCommentGQL extends Apollo.Mutation<CreateUserEvaluationPdiCommentMutation, CreateUserEvaluationPdiCommentMutationVariables> {
    document = CreateUserEvaluationPdiCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserEvaluationPdiTaskDocument = gql`
    mutation CreateUserEvaluationPdiTask($data: CreateUserEvaluationTaskInput!) {
  createUserEvaluationPdiTask(data: $data) {
    ...UserEvaluationPdiTask
  }
}
    ${UserEvaluationPdiTaskFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserEvaluationPdiTaskGQL extends Apollo.Mutation<CreateUserEvaluationPdiTaskMutation, CreateUserEvaluationPdiTaskMutationVariables> {
    document = CreateUserEvaluationPdiTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserEvaluationPdiTaskDocument = gql`
    mutation UpdateUserEvaluationPdiTask($data: UpdateUserEvaluationPdiTaskInput!) {
  updateUserEvaluationPdiTask(data: $data) {
    ...UserEvaluationPdiTask
  }
}
    ${UserEvaluationPdiTaskFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserEvaluationPdiTaskGQL extends Apollo.Mutation<UpdateUserEvaluationPdiTaskMutation, UpdateUserEvaluationPdiTaskMutationVariables> {
    document = UpdateUserEvaluationPdiTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserEvaluationPdiTaskStatusDocument = gql`
    mutation UpdateUserEvaluationPdiTaskStatus($id: String!) {
  updateUserEvaluationPdiTaskStatus(id: $id) {
    ...UserEvaluationPdiTask
  }
}
    ${UserEvaluationPdiTaskFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserEvaluationPdiTaskStatusGQL extends Apollo.Mutation<UpdateUserEvaluationPdiTaskStatusMutation, UpdateUserEvaluationPdiTaskStatusMutationVariables> {
    document = UpdateUserEvaluationPdiTaskStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUserEvaluationPdiTaskDocument = gql`
    mutation RemoveUserEvaluationPdiTask($id: String!) {
  removeUserEvaluationPdiTask(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUserEvaluationPdiTaskGQL extends Apollo.Mutation<RemoveUserEvaluationPdiTaskMutation, RemoveUserEvaluationPdiTaskMutationVariables> {
    document = RemoveUserEvaluationPdiTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFeedbackDocument = gql`
    mutation CreateFeedback($input: CreateFeedbackInput!) {
  createFeedback(data: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFeedbackGQL extends Apollo.Mutation<CreateFeedbackMutation, CreateFeedbackMutationVariables> {
    document = CreateFeedbackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFeedbackDocument = gql`
    mutation UpdateFeedback($input: UpdateFeedbackInput!) {
  updateFeedback(data: $input) {
    ...Feedback
  }
}
    ${FeedbackFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFeedbackGQL extends Apollo.Mutation<UpdateFeedbackMutation, UpdateFeedbackMutationVariables> {
    document = UpdateFeedbackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveFeedbackDocument = gql`
    mutation RemoveFeedback($id: String!) {
  removeFeedback(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveFeedbackGQL extends Apollo.Mutation<RemoveFeedbackMutation, RemoveFeedbackMutationVariables> {
    document = RemoveFeedbackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveFeedbackFileDocument = gql`
    mutation RemoveFeedbackFile($id: String!) {
  removeFeedbackFile(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveFeedbackFileGQL extends Apollo.Mutation<RemoveFeedbackFileMutation, RemoveFeedbackFileMutationVariables> {
    document = RemoveFeedbackFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchFeedbackDocument = gql`
    query SearchFeedback($data: SearchFeedbackInput!) {
  searchFeedback(data: $data) {
    ...FeedbackPage
  }
}
    ${FeedbackPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchFeedbackGQL extends Apollo.Query<SearchFeedbackQuery, SearchFeedbackQueryVariables> {
    document = SearchFeedbackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    mutation Login($code: String!, $redirectUri: String!, $email: String!) {
  login(data: {code: $code, redirectUri: $redirectUri, email: $email}) {
    user {
      id
      name
      email
      re
      photo
      profile
      status
      createdBy {
        id
        name
      }
      createdAt
      deletedAt
      updatedAt
    }
    token
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUnitiesDocument = gql`
    query GetUnities {
  unities {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnitiesGQL extends Apollo.Query<GetUnitiesQuery, GetUnitiesQueryVariables> {
    document = GetUnitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUnitiesByCountryDocument = gql`
    query GetUnitiesByCountry($input: String!) {
  getUnitiesByCountry(id: $input) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnitiesByCountryGQL extends Apollo.Query<GetUnitiesByCountryQuery, GetUnitiesByCountryQueryVariables> {
    document = GetUnitiesByCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserGQL extends Apollo.Query<CurrentUserQuery, CurrentUserQueryVariables> {
    document = CurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersDocument = gql`
    query GetUsers {
  users {
    id
    name
    email
    re
    photo
    profile
    status
    unity {
      ...Unity
    }
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersGQL extends Apollo.Query<GetUsersQuery, GetUsersQueryVariables> {
    document = GetUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchUserDocument = gql`
    query SearchUser($data: SearchUserInput!) {
  searchUser(data: $data) {
    ...UserPage
  }
}
    ${UserPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchUserGQL extends Apollo.Query<SearchUserQuery, SearchUserQueryVariables> {
    document = SearchUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersByProfileDocument = gql`
    query UsersByProfile($data: String!) {
  usersByProfile(profile: $data) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersByProfileGQL extends Apollo.Query<UsersByProfileQuery, UsersByProfileQueryVariables> {
    document = UsersByProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LeadersByManagerDocument = gql`
    query LeadersByManager($profile: String!, $id: String) {
  leaderByManager(profile: $profile, id: $id) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LeadersByManagerGQL extends Apollo.Query<LeadersByManagerQuery, LeadersByManagerQueryVariables> {
    document = LeadersByManagerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserByNameDocument = gql`
    query UserByName($data: String!) {
  userByName(name: $data) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserByNameGQL extends Apollo.Query<UserByNameQuery, UserByNameQueryVariables> {
    document = UserByNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchUserEvaluationsDocument = gql`
    query SearchUserEvaluations($data: SearchUserEvaluationInput!) {
  searchUserEvaluations(data: $data) {
    ...UserEvaluationPage
  }
}
    ${UserEvaluationPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchUserEvaluationsGQL extends Apollo.Query<SearchUserEvaluationsQuery, SearchUserEvaluationsQueryVariables> {
    document = SearchUserEvaluationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserDocument = gql`
    query User($id: String!) {
  user(id: $id) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserGQL extends Apollo.Query<UserQuery, UserQueryVariables> {
    document = UserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(data: $input) {
    id
    name
    email
    re
    photo
    profile
    status
    unity {
      ...Unity
    }
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(data: $input) {
    id
    name
    email
    re
    photo
    profile
    status
    unity {
      ...Unity
    }
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUserDocument = gql`
    mutation RemoveUser($id: String!) {
  removeUser(id: $id) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUserGQL extends Apollo.Mutation<RemoveUserMutation, RemoveUserMutationVariables> {
    document = RemoveUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }